export default {
  gettersTitleMenu(state) {
     return state.titleMenus
  },
}